<template>
  <div class="wrapper">
    <AFlatButton
      data-cy="button-selectLanguage-en"
      @click="()=>setLang('en')"
    >
      {{ $t("locale.en") }}
    </AFlatButton>
    <AFlatButton
      data-cy="button-selectLanguage-de"
      @click="()=>setLang('de')"
    >
      {{ $t("locale.de") }}
    </AFlatButton>
  </div>
</template>

<script>
import { IonButton } from "@ionic/vue";
import { useStore } from "@/composables/useTypedStore";
import AFlatButton from "@/components/Base/AFlatButton";
export default {
  name: "SelectLanguage",
  components: {
    AFlatButton,
  },
  props: {},
  setup() {
    const store = useStore();
    function setLang(newLanguage) {
      store.commit("app/setLocale", newLanguage);
      location.reload();
    }
    return {
      setLang,
    };
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  border: none;
  border-radius: 8px;
  padding: 2px 4px;
  font-size: 12px;
  min-width: 35px;
  min-height: 20px;
  //color: white;
}
</style>